import { FerryVehicleType } from '@shared/interfaces/ferry';

export interface Journey {
    type: JourneyType;
    time?: string | null;
    segments: JourneySegment[];
    company: JourneyCompany;
}

export type JourneyType = 'Ferry' | 'Flight' | 'Transfer';

export enum JourneyDateDisplay {
    Time,
    Date,
    DateTime,
}

export interface JourneySegment {
    departure: JourneyLocation;
    arrival: JourneyLocation;
    company: JourneyCompany;
    class?: string | null;
    time?: string | null;
    stopTime?: string | null;
    labels?: string[] | null;
    extras?: JourneyExtra[];
    technicalStop?: boolean | null;
}

export interface JourneyLocation {
    date: Date | null;
    dateDisplay?: JourneyDateDisplay;
    code: string | null;
    name: string | null;
    location: string | null;
}

export interface JourneyCompany {
    logo?: string | null;
    number: string | null;
    name: string | null;
    ferryName?: string | null;
}

export interface JourneyExtra {
    type: JourneyExtraType;
    title: string;
    description?: string;
    quantity: number;
}

export interface JourneyExtraVehicle {
    type: JourneyExtraType.Vehicle;
    title: string;
    description?: string;
    quantity: number;
    vehicleType?: FerryVehicleType;
}

export enum JourneyExtraType {
    Accommodation = 'Accommodation',
    Cabin = 'Cabin',
    Seat = 'Seat',
    Pet = 'Pet',
    Meal = 'Meal',
    Lounge = 'Lounge',
    Vehicle = 'Vehicle',
}
